export function getInvoiceRegistrationStatusText(value) {
  const map = {
    done: "Tamamlandı",
    pending: "Bekliyor",
    processing: "İşleniyor",
    running: "İşleniyor",
    failed: "Hata",
    error: "Hata",
    unknown: "Bilinmiyor",
  };

  return map[value] || value;
}

function hasAccounting(invoice) {
  if (invoice.has_accounting !== undefined) {
    return Boolean(invoice.has_accounting);
  }

  return Boolean(invoice.accounting_id);
}

function isPendingRegistration(invoice) {
  if (invoice.is_pending_registration !== undefined) {
    return Boolean(invoice.is_pending_registration);
  }

  return (
    (invoice.accounting_e_invoice_id !== null &&
      invoice.accounting_e_invoice_id !== undefined) ||
    (invoice.accounting_e_archive_id !== null &&
      invoice.accounting_e_archive_id !== undefined)
  );
}

function isRegistered(invoice) {
  if (invoice.is_registered !== undefined) {
    return Boolean(invoice.is_registered);
  }

  return Boolean(invoice.accounting_registered_at);
}

function hasReversal(invoice) {
  if (invoice.has_reversal !== undefined) {
    return Boolean(invoice.has_reversal);
  }

  return Boolean(invoice.reversal_verified_at);
}

export function getInvoiceWorkflowStatusText(invoice) {
  if (hasReversal(invoice)) {
    return "İptal Edildi";
  }

  if (isRegistered(invoice)) {
    return "Resmileşti";
  }

  if (
    invoice.accounting_registration_status === "error" ||
    invoice.accounting_registration_status === "failed"
  ) {
    return "Resmileştirme Hatası";
  }

  if (isPendingRegistration(invoice)) {
    return "Resmileştirme Bekliyor";
  }

  if (hasAccounting(invoice)) {
    return "Paraşüt'e Gönderildi";
  }

  return "Taslak";
}

export function getInvoiceWorkflowStatusDate(invoice) {
  if (hasReversal(invoice)) {
    return invoice.reversal_verified_at;
  }

  return null;
}
